import { Loader, Modal, Page } from "@wix/design-system";
import React from "react";

interface PagerLoaderProps {
}

const PageLoader: React.FC<PagerLoaderProps> = ({ }) => {
    return <Page>
        <Page.Content>
            <Modal
                screen="desktop"
                isOpen={true}
                onRequestClose={() => { }}
            >
                <Loader size="large" />
            </Modal>
        </Page.Content>
    </Page>
}

export default PageLoader;